import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { primaryFont, wMedium } from 'Utils/utilsStyle';
import UploadComponent from './UploadComponent';
import UploadDocumentFooter from './UploadDocumentFooter';
import AddLinkComponent from './AddLinkComponent';
import { useSelector } from 'react-redux';
import { selectIsDellUser } from 'Selector/GlobalSearchContentSelector';

const Wrapper = styled.div`
&.disableWrapper {
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
}
&.addLinkWrapper {
  border-radius: 4.961px;
  border: 1.417px dashed #C4C4C4;
  background: linear-gradient(180deg, rgba(217, 217, 217, 0.60) 0%, rgba(232, 232, 232, 0.12) 100%), #F7F7F7;
  &:hover {
    border-color: #7ddb9b;
    background: linear-gradient(rgba(30, 194, 82, 0.19) 0%, rgba(30, 194, 82, 0.043) 100%);
    .upload-document-footer {
      border-color: #7ddb9b;
      .icon-div {
        svg {
          path {
            fill: #7ddb9b;
          }
        }
        .icon-title {
          color: #7ddb9b;
        }
      }
    }
  }
}
`;

const NoteArea = styled.div`
  .heading {
    color: #7E7E7E;
    font-family: ${primaryFont};
    font-size: 12px;
    font-style: italic;
    font-weight: ${wMedium};
    line-height: 14px;
    letter-spacing: -0.201px;
    margin-bottom: 0px;
    margin-top: 6px;
    .head {
      color: #424B50;
      margin-right: 2px;
    }
  }
`;

type Props = {
  addLinkState: boolean,
  loader: boolean,
  inSmartDrawer: boolean,
};

const UploadDocumentComponent = function UploadDocumentComponent(props: Props) {
  const {
    addLinkState, loader, inSmartDrawer,
  } = props;
  const isDellUser = useSelector(selectIsDellUser);
  return (
    <>
      <Wrapper className={classNames('upload-document-component', {
        disableWrapper: loader,
        addLinkWrapper: addLinkState,
      })}
      >
        {addLinkState ? (
          <AddLinkComponent />
        ) : (
          <UploadComponent
            inSmartDrawer={inSmartDrawer}
          />
        )}
        {addLinkState ? (<UploadDocumentFooter />) : null}
      </Wrapper>
      {isDellUser
        ? (
          <NoteArea>
            <h6 className="heading">
              <span className="head">Note: </span>
              You should not upload any Dell confidential, proprietary, or sensitive documents
            </h6>
          </NoteArea>
        ) : null}
    </>
  );
};

export default UploadDocumentComponent;
